import { ApplicationResponse } from '../../types/rest-api';

export const getProdEnv = ( applications: ApplicationResponse[] ) => {
	return applications.find( app => app['environment-type'] === 'production' );
};

export const getStagingEnv = ( applications: ApplicationResponse[] ) => {
	return applications.find( app => app.id.match( '-staging' ) || app.id.match( '-stag-' ) );
};
